import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["className", "children", "scrollbars", "disableScrollbars", "autoWidth"],
  _excluded2 = ["options", "style"],
  _excluded3 = ["className"],
  _excluded4 = ["show"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { OverlayScrollbarsComponent } from '@isyc-react/design/scrollbar';
import clsx from 'clsx';
import { useResizeObserver } from '@isyc-react/core/resize-observer';
import "./overlay-base.style.scss";
export const OverlayContainerBase = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      className,
      children,
      scrollbars = {},
      disableScrollbars,
      autoWidth
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
      options = {},
      style
    } = scrollbars,
    restScrollbars = _objectWithoutProperties(scrollbars, _excluded2);
  const {
      className: scrollbarsClassName
    } = options,
    restOptions = _objectWithoutProperties(options, _excluded3);
  const {
    reference,
    offset = -8
  } = autoWidth !== null && autoWidth !== void 0 ? autoWidth : {};
  const {
    width: originalWidth
  } = useResizeObserver({
    ref: reference
  });
  const width = React.useMemo(() => originalWidth ? originalWidth + offset : undefined, [originalWidth, offset]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('overlay-base-container', className),
    ref: ref
  }, rest), disableScrollbars ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(OverlayScrollbarsComponent, _extends({}, restScrollbars, {
    style: _objectSpread({
      width
    }, style),
    options: _objectSpread(_objectSpread({}, restOptions), {}, {
      scrollbars: _objectSpread({
        autoHide: 'move'
      }, restOptions.scrollbars),
      className: clsx('overlay-base-scroll os-theme-dark overlay-base-scroll-handle', scrollbarsClassName)
    })
  }), children)));
});
export const OverlayContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      show
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(OverlayContainerBase, _extends({}, rest, {
    ref: ref
  })));
});